import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Typography } from 'antd';

import {
  setClearFilters,
  updateMultipleFilters
} from 'features/filters/filtersSlice';
import { selectActiveModule } from 'features/moduleConfigs/moduleConfigsSelectors';

import { getModuleDefaultFilters } from 'utils/getModuleDefaultFilters';
import { scrollToTop } from 'utils/scrollToTop';

const TitleContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const activeModule = useSelector(selectActiveModule);

  const handleReset = () => {
    dispatch(setClearFilters());

    const moduleDefaultFilters = getModuleDefaultFilters(activeModule, t);
    if (moduleDefaultFilters) {
      dispatch(updateMultipleFilters(moduleDefaultFilters));
    }

    scrollToTop();
  };

  return (
    <div className="title-container">
      <Typography className="title-text">
        {t('common.label.filters')}
      </Typography>
      <Button type="link" danger onClick={handleReset}>
        {t('common.label.resetAll')}
      </Button>
    </div>
  );
};

export default TitleContainer;
